// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.partner-band {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.10);
  border-radius: 12px;
  margin-bottom: 24px;
  overflow: hidden;
}

.partner-band__top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 32px;
  width: 100%;
  padding: 16px 32px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}

.partner-band__label {
  display: flex;
  flex-direction: column;
  gap: 3px;
  text-align: start;
}

.partner-band__label-title {
  font-size: 12px;
  font-weight: 700;
  color: rgba(255, 255, 255, 0.65);
  text-transform: uppercase;
  letter-spacing: 0.05em;
  line-height: 1.35;
}

.partner-band__label-sub {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.4);
}

.partner-band__logos {
  display: flex;
  align-items: center;
  gap: 24px;
}

.partner-band__logos img {
  height: 30px;
  width: auto;
  object-fit: contain;
  filter: brightness(0) invert(1);
  opacity: 0.85;
}

.partner-band__features {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.partner-band__feature {
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1 1;
  padding: 14px 28px;
  border-right: 1px solid rgba(255, 255, 255, 0.08);
}

.partner-band__feature:last-child {
  border-right: none;
}

.partner-band__feature-icon {
  color: rgba(255, 255, 255, 0.5);
  flex-shrink: 0;
  display: flex;
  align-items: center;
}

.partner-band__feature-icon svg {
  width: 24px;
  height: 24px;
}

.partner-band__feature-text {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.partner-band__feature-name {
  font-size: 14px;
  font-weight: 700;
  color: rgba(255, 255, 255, 0.9);
  white-space: nowrap;
}

.partner-band__feature-desc {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.45);
  line-height: 1.45;
}`, "",{"version":3,"sources":["webpack://./src/components/atoms/partnerBand/PartnerBand.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,MAAM;EACN,qCAAqC;EACrC,2CAA2C;EAC3C,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,kDAAkD;AACpD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,yBAAyB;EACzB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,+BAA+B;EAC/B,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,SAAO;EACP,kBAAkB;EAClB,iDAAiD;AACnD;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,cAAc;EACd,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gCAAgC;EAChC,iBAAiB;AACnB","sourcesContent":[".partner-band {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0;\n  background: rgba(255, 255, 255, 0.06);\n  border: 1px solid rgba(255, 255, 255, 0.10);\n  border-radius: 12px;\n  margin-bottom: 24px;\n  overflow: hidden;\n}\n\n.partner-band__top {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 32px;\n  width: 100%;\n  padding: 16px 32px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n}\n\n.partner-band__label {\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n  text-align: start;\n}\n\n.partner-band__label-title {\n  font-size: 12px;\n  font-weight: 700;\n  color: rgba(255, 255, 255, 0.65);\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  line-height: 1.35;\n}\n\n.partner-band__label-sub {\n  font-size: 13px;\n  color: rgba(255, 255, 255, 0.4);\n}\n\n.partner-band__logos {\n  display: flex;\n  align-items: center;\n  gap: 24px;\n}\n\n.partner-band__logos img {\n  height: 30px;\n  width: auto;\n  object-fit: contain;\n  filter: brightness(0) invert(1);\n  opacity: 0.85;\n}\n\n.partner-band__features {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n}\n\n.partner-band__feature {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex: 1;\n  padding: 14px 28px;\n  border-right: 1px solid rgba(255, 255, 255, 0.08);\n}\n\n.partner-band__feature:last-child {\n  border-right: none;\n}\n\n.partner-band__feature-icon {\n  color: rgba(255, 255, 255, 0.5);\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n}\n\n.partner-band__feature-icon svg {\n  width: 24px;\n  height: 24px;\n}\n\n.partner-band__feature-text {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.partner-band__feature-name {\n  font-size: 14px;\n  font-weight: 700;\n  color: rgba(255, 255, 255, 0.9);\n  white-space: nowrap;\n}\n\n.partner-band__feature-desc {\n  font-size: 14px;\n  color: rgba(255, 255, 255, 0.45);\n  line-height: 1.45;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
